const PARTICIPANTS = {
    globalauth: 'GlobalAuth (аккаунт и сессии)',
    payments: 'Платежи',
    locations: 'Локации',
    news: 'Новости',
    panel: 'VPN-панель (PanelManager)',
    users: 'Users (профиль и локальная очистка)',
};
const KINDS = {
    retrying: 'Участник повторяет сам',
    dead: 'Участник сдался',
    uncorrelated: 'Не связано с операцией',
};
const STATUSES = {
    open: 'Открыта',
    resolved: 'Закрыта',
};
const CODES = {
    deletion_temporarily_unavailable: 'Временная ошибка',
    deletion_attempts_exhausted: 'Попытки исчерпаны',
    deletion_command_rejected: 'Команда отклонена',
    deletion_message_uncorrelated: 'Сообщение не связано с операцией',
};
export const deletionFailureParticipantLabel = (value) => PARTICIPANTS[value] ?? value;
export const deletionFailureKindLabel = (value) => KINDS[value] ?? value;
export const deletionFailureStatusLabel = (value) => STATUSES[value] ?? value;
export const deletionFailureCodeLabel = (value) => CODES[value] ?? value;
export function deletionFailureStatusTone(value) {
    if (value === 'open')
        return 'danger';
    if (value === 'resolved')
        return 'ok';
    return 'neutral';
}
export function retryUnavailableReason(failure) {
    if (failure.status === 'resolved')
        return 'Запись уже закрыта.';
    if (failure.operation_id == null)
        return 'Нет связанной операции удаления.';
    if (failure.kind === 'uncorrelated') {
        return 'Сообщение нельзя связать с операцией удаления.';
    }
    if (failure.participant === 'users')
        return 'Локальный шаг Users нельзя переотправить.';
    return null;
}
export function canRetryDeletionFailure(failure) {
    return retryUnavailableReason(failure) == null;
}
export function formatDeletionFailureBadgeCount(value) {
    if (!Number.isFinite(value) || value <= 0)
        return null;
    return value > 99 ? '99+' : String(Math.floor(value));
}
